import { Module } from 'vuex';

import { actions } from '@/store/modules/profile/actions';
import { getters } from '@/store/modules/profile/getters';
import { mutations } from '@/store/modules/profile/mutations';
import { state } from '@/store/modules/profile/state';
import { ProfileState } from '@/store/modules/profile/types';
import { RootState } from '@/store/types';

export const profile: Module<ProfileState, RootState> = {
  namespaced: true,
  actions,
  getters,
  mutations,
  state,
};
